import GameStatesEnum from '../GameStatesEnum'
import BaseState from '@state/BaseState'
import { Signals} from "@/Imports";
import Facade from "@/Facade";

export default class LoadingState extends BaseState {

  begin() {
    Signals.continueBtnClick.add(this.onContinueBtnClick, this)
    Signals.loadAssets.dispatch()
  }

  onContinueBtnClick() {
    this.end()
  }

  end = () => {
    let gameState = GameStatesEnum.IDLE
    if(Facade.model.countAmountFreeBet > 0) {
      this.model.isFreespinsMode = true
      this.model.isFreespinsStarted = true
      this.isAuto = true  /// ????
    }
    // if (this.model.isShowFreebetsGamePopup && !this.model.isFreespinsStarted) {
    //   gameState = GameStatesEnum.FREE_SPINS_INTRO
    // }

    this.stateMachine.setState(gameState)
    Signals.gameInited.dispatch()
  }

  cleanUp() {
  }

}
